import { createSelector } from 'reselect';

import { PpeType } from 'constants/company';

const getPricingStatusState = state => state.loanApplication.pricingStatus;

export const selectPricingStatus = createSelector(
  getPricingStatusState,
  pricingStatus => pricingStatus,
);

export const selectIsLockedFromPricingStatus = createSelector(
  getPricingStatusState,
  pricingStatus => !!pricingStatus.isLocked,
);

export const selectIsLockPendingFromPricingStatus = createSelector(
  getPricingStatusState,
  pricingStatus => pricingStatus.isLockPending,
);

export const selectIsRelockRequiredFromPricingStatus = createSelector(
  getPricingStatusState,
  pricingStatus => pricingStatus.isRelockRequired,
);

export const selectPricingEngineTypeFromPricingStatus = createSelector(
  getPricingStatusState,
  pricingStatus => pricingStatus.pricingEngineType,
);

const selectProgramChangeConfiguration = createSelector(
  getPricingStatusState,
  pricingStatus => pricingStatus.programChangeConfiguration,
);

export const selectIsProgramChangeAllowed = createSelector(
  selectProgramChangeConfiguration,
  programChangeConfiguration => !!programChangeConfiguration.allowed,
);

export const selectIsProgramChangeDisabled = createSelector(
  [selectIsLockPendingFromPricingStatus, selectIsProgramChangeAllowed],
  (isLockPending, isProgramChangeAllowed) => isLockPending || !isProgramChangeAllowed,
);

export const selectProgramChangeReasons = createSelector(
  selectProgramChangeConfiguration,
  programChangeConfiguration => programChangeConfiguration.reasons ?? [],
);

export const selectIsUpdateRequestPending = createSelector(
  getPricingStatusState,
  pricingStatus => pricingStatus.isUpdateRequestPending,
);

const selectPriceConcessionConfiguration = createSelector(
  getPricingStatusState,
  pricingStatus => pricingStatus.priceConcessionConfiguration,
);

export const selectIsPriceConcessionAllowed = createSelector(
  selectPriceConcessionConfiguration,
  priceConcessionConfiguration => !!priceConcessionConfiguration.allowed,
);

export const selectIsNoPpeEngineTypeFromPricingStatus = createSelector(
  selectPricingEngineTypeFromPricingStatus,
  pricingEngineType => pricingEngineType === PpeType.NO_PPE,
);
